export default __webpack_public_path__ + "static/media/Custom-HUD-Registration Marks.1211a32f.jpg";